export function asTimeLeft(remainingSeconds: number): string {
  if (remainingSeconds <= 0) {
    return '';
  }

  const days = Math.floor(remainingSeconds / 86400);
  const hours = Math.floor((remainingSeconds % 86400) / 3600);
  const minutes = Math.floor((remainingSeconds % 3600) / 60);
  const seconds = remainingSeconds % 60;

  if (days > 0) {
    return `${days}d ${hours}h`;
  } else if (hours > 0) {
    return `${hours}h ${minutes}m`;
  } else {
    return `${minutes}m ${seconds}s`;
  }
}

export function calcIconColor(rank: number): string {
  if (rank === 1) {
    return '--game-trophy-gold-fill';
  } else if (rank === 2) {
    return '--game-trophy-silver-fill';
  } else if (rank === 3) {
    return '--game-trophy-bronze-fill';
  }
  return '--icon-fill';
}

export function calcIcon(rank: number): string {
  if (rank === 1) {
    return 'crown';
  }
  return 'medal';
}

export function getOrdinalSuffix(rank: number): string {
  if (rank % 10 === 1 && rank % 100 !== 11) return 'st';
  if (rank % 10 === 2 && rank % 100 !== 12) return 'nd';
  if (rank % 10 === 3 && rank % 100 !== 13) return 'rd';
  return 'th';
}

export function getDateString(unixTime: number): string {
  const date = new Date(unixTime);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString().slice(-2);
  return `${day}/${month}/${year}`;
}

export const isWholeNumber = (value: number): boolean => Math.floor(value) === value;
